import { useContext } from 'react';
import Context from './context';

export default function useLocalization() {
  const context = useContext(Context);
  return context;
}
